import AddressModal from '@module/addressModal';
import CustomFormModal from '@module/customFormModal';
import UserRegistrationModal from '@module/userRegistration';
import { getFormByGuestFormId } from '@storeData/customForms';
import { getUserByTenantAndMobile } from '@storeData/user';
import { Fragment, useEffect, useState } from 'react';
import { useCookies } from "react-cookie";
import { useSelector } from 'react-redux';

import {
  AiOutlineHome,
  CgWorkAlt,
  FaUserEdit,
  GrLocation,
  MdAddLocation,
  MdEditLocation
} from '@element/icons';
function ProfilePage() {

    const [openUserUpdationModal, setOpenUserUpdationModal] = useState(false);
    const [cookie, setCookie] = useCookies();
    const [userData, setUserData] = useState(cookie['user']);
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [selectedAddressToEdit, setSelectedAddressToEdit] = useState(null);
    const storeData: any = useSelector((state: any) => state.store.storeData);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const basicConfig = configData?.storeConfig?.basicConfig
    const [userAddresses, setUserAddresses] = useState([
        { type: 'Home', value: null, isNew: false, isEdited: false, icon: <AiOutlineHome /> },
        { type: 'Work', value: null, isNew: false, isEdited: false, icon: <CgWorkAlt /> },
        { type: 'Other', value: null, isNew: false, isEdited: false, icon: <GrLocation /> },
    ])
    const [openCustomFormModal, setOpenCustomFormModal] = useState({ active: false, data: null });
    const store = useSelector((state: any) => state);
    const languageData: any = store.languageKeywords

    useEffect(() => {
        if (cookie['user']) {
            const { tenantId, storeId, mobileNo } = cookie['user']
            getUserByTenantAndMobile(tenantId, storeId, mobileNo).then((res: any) => {
                if (res && res.data) {
                    setUserData(res.data);
                }
            })
        }
    }, [cookie])

    useEffect(() => {
        if (userData) {
            if (userData?.addressList) {
                const userAddressesCopy = [...userAddresses];
                userAddressesCopy.map((userAdd) => {
                    userData.addressList.map((data) => {
                        if (userAdd.type == data.type) {
                            userAdd.value = data;
                        }
                    })
                })
                setUserAddresses(userAddressesCopy);
            }
        }
    }, [userData])

    const handleAddressModalResponse = (address) => {
        if (address) {
            const newAddress = { ...address };
            const userAddressesCopy = [...userAddresses];
            userAddressesCopy.map((userAdd) => {
                if (userAdd.type == newAddress.type) {
                    userAdd.value = address;
                }
            })
            setUserAddresses(userAddressesCopy);
        }
        setSelectedAddressToEdit(null);
        setOpenAddressModal(false)
    }

    const editAddress = (address) => {
        setSelectedAddressToEdit(address);
        setOpenAddressModal(true);
    }

    const getDatesDiffInDays = (date1: any, date2: any) => {
        date1 = new Date(date1);
        date2 = new Date(date2);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    }

    const onFormClick = (formDetails: any) => {
        getFormByGuestFormId(formDetails.id).then((res: any) => {
            if (res) {
                setOpenCustomFormModal({ active: true, data: res });
            }
        })
    }

    return (
        <>
            <div className="profile-page-wrap checkout-page-wrap">
                {userData && <div className="guest-details-wrap glass-card">
                    <div className='sub-heading'>{languageData["Guest Details"] ? languageData["Guest Details"] : "Guest Details"}</div>
                    <div className="username">{userData.firstName} {userData.lastName}</div>
                    <div className="usernumber">{basicConfig.multipleCountryCode ? '+' + userData.countryCode : ""} {userData.mobileNo}</div>
                    <div className="usernumber">{userData.email}</div>
                    <div className="edit-user-icon d-f-c" onClick={() => setOpenUserUpdationModal(true)}><FaUserEdit /></div>
                </div>}

                {Boolean(userData?.referralCode) && <div className="guest-details-wrap glass-card clearfix" style={{ display: "flex", gap: 10 }}>
                    <div className='label' style={{ padding: "unset", fontWeight: 600 }}> {languageData["Referral Code"] ? languageData["Referral Code"] : "Referral Code"}:</div> {userData?.referralCode}
                </div>}

                {Boolean(userData?.loyalty?.availablePointsAll || userData?.loyalty?.availablePointsProduct || userData?.loyalty?.availablePointsService) && <div className="guest-details-wrap glass-card">
                    {Boolean(userData?.loyalty?.availablePointsAll) ? <div className='sub-heading'> {languageData["Available Loyalty Points"] ? languageData["Available Loyalty Points"] : "Available Loyalty Points"}: <span className="value">{userData?.loyalty?.availablePointsAll}</span> </div> : <>
                        {Boolean(userData?.loyalty?.availablePointsProduct) && <div className='sub-heading'> {languageData["Available Product Loyalty Points"] ? languageData["Available Product Loyalty Points"] : "Available Product Loyalty Points"}: <span className="value">{userData?.loyalty?.availablePointsProduct}</span> </div>}
                        {Boolean(userData?.loyalty?.availablePointsService) && <div className='sub-heading'> {languageData["Available Service Loyalty Points"] ? languageData["Available Service Loyalty Points"] : "Available Service Loyalty Points"}: <span className="value">{userData?.loyalty?.availablePointsService}</span> </div>}
                        {Boolean(userData?.loyalty?.availablePointsService) && <div className='sub-heading'> {languageData["Available Package Loyalty Points"] ? languageData["Available Package Loyalty Points"] : "Available Package Loyalty Points"}: <span className="value">{userData?.loyalty?.availablePointsPackage}</span> </div>}
                    </>}
                </div>}

                {(userData?.membership && configData?.storeConfig?.basicConfig?.membership) && <div className="guest-details-wrap glass-card">
                    <div className='pkg-heading'> {languageData["Membership Details"] ? languageData["Membership Details"] : "Membership Details"}</div>
                    {userData?.membership?.map((item: any, index: number) => {
                        return (
                            <>
                                <div className="username">{index + 1}. {item.membershipName}  {languageData["Membership"] ? languageData["Membership"] : "Membership"}</div>
                                {Boolean(item?.membershipCode) && <div className="usernumber"> {languageData["Membership Id"] ? languageData["Membership Id"] : "Membership Id"}:{item.membershipCode}</div>}
                                {item.typeId === 1 && <div className="usernumber"> {languageData["Available Balance"] ? languageData["Available Balance"] : "Available Balance"}: {storeData?.configData?.currencySymbol} {item.balanceAmount}</div>}
                                {item.typeId === 3 && <div className="usernumber"> {languageData["Available Hours"] ? languageData["Available Hours"] : "Available Hours"}: {(item.balanceMinutes / 60).toFixed(2)}hrs</div>}
                                {item.toDate && <>
                                    {(getDatesDiffInDays(new Date(item.toDate), new Date()) <= 10) && <>
                                        <div className="usernumber error">{`Expires in ${getDatesDiffInDays(new Date(item.toDate), new Date())} days`}</div>
                                    </>}
                                </>}
                                {index !== userData?.membership?.length - 1 && <hr></hr>}
                            </>
                        );
                    })}
                </div>}

                {Boolean(basicConfig.customForms) && Boolean(userData?.guestForms?.length) && <div className="guest-details-wrap glass-card">
                    <div className='sub-heading'> {languageData["Submitted forms"] ? languageData["Submitted forms"] : "Submitted forms"}</div>
                    {userData?.guestForms?.map((item: any, index: number) => {
                        return (
                            <Fragment key={index}>
                                <div className="username" onClick={() => onFormClick(item)}>{index + 1}. {item.formName}, {new Date(item.modifiedOn).toLocaleDateString()}</div>
                                {index !== userData?.guestForms?.length - 1 && <hr></hr>}
                            </Fragment>
                        );
                    })}
                </div>}

                {(Boolean(userData?.packages?.length) && configData?.storeConfig?.basicConfig?.packages) && <div className="guest-details-wrap glass-card">
                    <div className='pkg-heading'> {languageData["Package Details"] ? languageData["Package Details"] : "Package Details"}</div>
                    {userData?.packages?.map((item: any, index: number) => {
                        return <div className='guest-pkg-details' key={index}>
                            <div className="username">{index + 1}. {item.packageName}  {languageData["Package"] ? languageData["Package"] : "Package"}</div>
                            {item.quantifiedCustomPackage && <>
                                <div className="validity">Available Quantity: {item.availableItemsQuantity}</div>
                                <div className="validity">Used Quantity: {Number(item.totalItemsQuantity) - Number(item.availableItemsQuantity)}</div>
                            </>}
                            {item.services && <div className="package-services-heading">
                                <div className='service-col-heading'>{languageData["Services"] ? languageData["Services"] : "Services"}</div>
                                <div className='service-col-heading'>{languageData["Available"] ? languageData["Available"] : "Available"}</div>
                            </div>}
                            {item.services && item.services.map((service: any, ni: number) => {
                                return <div className='package-services' key={ni}>
                                    <div className='service-name'>-{service.name}</div>
                                    <div className='service-qty'>{service.balanceQuantity ? service.balanceQuantity : 0}</div>
                                </div>
                            })}
                            {item.toDate && <>
                                {(getDatesDiffInDays(new Date(item.toDate), new Date()) <= 10) && <>
                                    <div className="usernumber error">{`Expires in ${getDatesDiffInDays(new Date(item.toDate), new Date())} days`}</div>
                                </>}
                            </>}
                            {index !== userData?.packages?.length - 1 && <hr></hr>}
                        </div>
                    })}
                </div>}

                {(Boolean(userData?.giftCards?.length) && configData?.storeConfig?.basicConfig?.giftCard) && <div className="guest-details-wrap glass-card">
                    <div className='sub-heading'> {languageData["Giftcard Details"] ? languageData["Giftcard Details"] : "Giftcard Details"}</div>
                    {userData?.giftCards?.map((item: any, index: number) => {
                        return (
                            <div key={index}>
                                <div className="username">{index + 1}. {item.giftCardName}  {languageData["GiftCard"] ? languageData["GiftCard"] : "GiftCard"}</div>
                                {<div className="usernumber"> {languageData["Giftcard Id"] ? languageData["Giftcard Id"] : "Giftcard Id"}: {item.giftCardNo}</div>}
                                {<div className="usernumber"> {languageData["Available Balance"] ? languageData["Available Balance"] : "Available Balance"}: {storeData?.configData?.currencySymbol} {item.balanceAmount}</div>}
                                {item.toDate && <>
                                    {(getDatesDiffInDays(new Date(item.toDate), new Date()) <= 10) && <>
                                        <div className="usernumber error">{`Expires in ${getDatesDiffInDays(new Date(item.toDate), new Date())} days`}</div>
                                    </>}
                                </>}
                                {index !== userData?.giftCards?.length - 1 && <hr></hr>}
                            </div>
                        );
                    })}
                </div>}

                {((!!userData?.advanceAmount || !!userData?.balAmount) && configData?.storeConfig?.basicConfig?.advance_and_balance) && <div className="guest-details-wrap glass-card">
                    <div className='sub-heading'> {languageData["Advances & Balances"] ? languageData["Advances & Balances"] : "Advances & Balances"}</div>
                    {!!userData?.advanceAmount && <div className="usernumber"> {languageData["Advance Paid"] ? languageData["Advance Paid"] : "Advance Paid"}: {storeData?.configData?.currencySymbol} {userData?.advanceAmount}</div>}
                    {!!userData?.balAmount && <div className="usernumber"> {languageData["Due Balance"] ? languageData["Due Balance"] : "Due Balance"}: {storeData?.configData?.currencySymbol} {userData?.balAmount}</div>}
                </div>}

                <div className="address-wrap glass-card">
                    <div className="sub-heading"> {languageData["Delivery Address"] ? languageData["Delivery Address"] : "Delivery Address"}</div>
                    {userAddresses.map((address) => {
                        return <div className={`add-type-details glass-card`} key={Math.random()} >
                            <div className="type-icon-wrap">
                                <div className="icon-wrap d-f-c">{address.icon}</div>
                                <div className="type-name">{languageData[address.type] ? languageData[address.type] : address.type}</div>
                            </div>
                            {address.value && address.value.line ? <div className="address-details">
                                <div className="line">{address.value.line}</div>
                                <div className="line">
                                    {address.value.area && <>{address.value.area},</>}
                                    {address.value.city && <>{address.value.city},</>}
                                    {address.value.code && <>{address.value.code}</>}
                                </div>
                                <div className="edit-address-icon d-f-c" onClick={() => editAddress(address.value)}><MdEditLocation /></div>
                            </div> :
                                <div className="address-details">
                                    <div className="line"> {languageData["No address saved yet"] ? languageData["No address saved yet"] : "No address saved yet"}</div>
                                    <div className="edit-address-icon d-f-c" onClick={() => setOpenAddressModal(true)}><MdAddLocation /></div>
                                </div>
                            }
                        </div>
                    })}
                </div>

                {openUserUpdationModal && <UserRegistrationModal
                    handleResponse={() => setOpenUserUpdationModal(false)}
                    isApppGrpChangeOnUserGdrChange={true}
                    open={true}
                    fromPage="PROFILE"
                    heading={'Update Profile Details'}
                />}
                <AddressModal
                    open={openAddressModal}
                    handleClose={(res) => handleAddressModalResponse(res)}
                    addressToEdit={selectedAddressToEdit}
                    userId={userData?.id}
                />

            </div>
            <CustomFormModal
                open={openCustomFormModal.active}
                handleClose={(res) => setOpenCustomFormModal({ active: false, data: null })}
                formDetails={openCustomFormModal.data}
            />
        </>
    )
}

export default ProfilePage;